import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getAnimals, deleteAnimal, forceDeleteAnimal, getAnimalsByMotherId } from "../../../api/animalsApi";
import '../../eleveur/eleveurAnimalsList/animalsList.css'
import swal from "sweetalert";
import { MdOutlineManageSearch } from "react-icons/md";

export default function AdminAnimalList() {
  const [animals, setAnimals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');


  useEffect(() => {
    setLoading(true);
    getAnimals()
      .then(data => setAnimals(data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const filteredAnimals = animals.filter(a => {
    const search = searchTerm.toLowerCase();
    return a.numero?.toString().toLowerCase().includes(search) ||
      a.nom?.toLowerCase().includes(search) ||
      a.race?.nom?.toLowerCase().includes(search) ||
      a.phase?.titre?.toLowerCase().includes(search) ||
      a.poids?.toString().toLowerCase().includes(search) ||
      a.genre?.toLowerCase().includes(search) ||
      a.user?.nom?.toLowerCase().includes(search);
  });

  async function handleDelete(id) {

    const enfants = await getAnimalsByMotherId(id)
    const aEnfants = enfants.length < 1

    const content = document.createElement('div');
    content.innerHTML = `
      <p style="margin-bottom: 15px;">Etes vous sure de supprimer cette animal ?</p>
      ${aEnfants ? `
        <div style="margin-top: 15px; padding: 10px; background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 4px;">
          <label style="display: flex; align-items: center; cursor: pointer; font-weight: bold; color: #856404;">
            <input type="checkbox" id="forceDeleteCheckbox" style="margin-right: 10px; width: 18px; height: 18px; cursor: pointer;" />
            <span>Supprimer définitivement !!</span>
          </label>
        </div>
      ` : ''}
    `;

    swal({
      title: "Etes vous sûr?",
      content: content,
      icon: "warning",
      buttons: ['Annuler', 'Oui'],
    }).then(async (good) => {
      if (good) {
        try {

          const force = aEnfants && document.getElementById('forceDeleteCheckbox')?.checked;

          if (force) {
            await forceDeleteAnimal(id);
          } else {
            await deleteAnimal(id);
          }
          setAnimals(an => an.filter(a => a.id !== id));
          swal("Animal supprimé!", { icon: "success" });
        } catch (e) { console.error(e); swal("Not deleted!"); }
      } else {
        swal("N'est pas supprimer!");
      }
    });
  }

  return (
    <div className="animaux">
      <div className="animaux-header">
        <h2>Animaux</h2>
        <div className="animals-count">
          <div className="count-badge">{animals.length}</div>
          <div className="count-label">Animaux</div>
        </div>

        <Link to={'/admin/add-animal'} className="add-animal">
          Ajouter un animal
        </Link>
      </div>
      <div className="search-container">
        <div className="search-wrapper">
          <input
            type="text"
            className="search-input"
            placeholder="Rechercher par numéro, nom, race, phase, responsable..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <span className="search-icon"><MdOutlineManageSearch /></span>
          {searchTerm && (
            <button
              className="search-clear visible"
              onClick={() => setSearchTerm('')}
            >
              X
            </button>
          )}
        </div>
        {searchTerm && (
          <div className="search-results-info">
            <strong>{filteredAnimals.length}</strong> résultat{filteredAnimals.length !== 1 ? 's' : ''} trouvé{filteredAnimals.length !== 1 ? 's' : ''}
          </div>
        )}
      </div>

      {loading && <p className="loading-messageL">Chargement...</p>}

      {!loading && animals.length === 0 && (
        <p className="Rien-a-faireL">Aucun animal disponible</p>
      )}


      {!loading && animals.length > 0 && (
        <div className="table-container">
          {!loading && animals.length > 0 && searchTerm && filteredAnimals.length === 0 && (
            <div className="no-results-message">
              <h3>Aucun résultat trouvé</h3>
              <p>
                Aucun animal ne correspond à votre recherche <span className="search-term">"{searchTerm}"</span>
              </p>
            </div>
          )}
          <table className="animals-table">
            <thead>
              <tr>
                <th>Animal</th>
                <th>Race</th>
                <th>Phase</th>
                <th>Poids</th>
                <th>Genre</th>
                <th>Responsable</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredAnimals.map((a, index) => (
                <tr key={a.id} style={{ '--index': index }}>
                  <td data-label="Animal">
                    <div className="animal-name-cell">
                      <span className="animal-numero">#{a.numero}</span>
                      <span className="animal-nom">{a.nom}</span>
                    </div>
                  </td>

                  <td data-label="Race">
                    <span className="table-badge">
                      {a.race?.nom || a.race_id}
                    </span>
                  </td>

                  <td data-label="Phase">
                    {a.phase?.titre || a.phase_id}
                  </td>

                  <td data-label="Poids">
                    {a.poids ? `${a.poids} kg` : 'Non défini'}
                  </td>

                  <td data-label="Genre">
                    {a.genre || 'Non défini'}
                  </td>

                  <td data-label="Responsable">
                    <div className="responsable-cell">
                      <div className="responsable-avatar">
                        {a.user?.nom?.charAt(0).toUpperCase() || '?'}
                      </div>
                      <span>{a.user?.nom || 'Non assigné'}</span>
                    </div>
                  </td>

                  <td data-label="Actions">
                    <div className="actions-cell">
                      <Link
                        to={'/admin/edit/' + a.id}
                        className="action-btn action-btn-edit"
                      >
                        Modifier
                      </Link>
                      <Link
                        to={'/admin/animal/details/' + a.id}
                        className="action-btn action-btn-details"
                      >
                        Détails
                      </Link>
                      <button
                        onClick={() => handleDelete(a.id)}
                        className="action-btn action-btn-delete"
                      >
                        Supprimer
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}


